/**
 * @file Progress 进度条
 * @description 线性进度展示；支持成功/危险语义色。
 *
 * @whenToUse 上传进度、任务完成度。
 * @whenNotToUse 加载不确定态（用 Spinner）。
 */

import { cn } from '@/lib/cn.ts'

export type ProgressStatus = 'default' | 'success' | 'danger'

export type ProgressProps = {
  /** 0–100 */
  percent: number
  /** 是否显示百分比文案 */
  showInfo?: boolean
  status?: ProgressStatus
  className?: string
}

const barClass: Record<ProgressStatus, string> = {
  default: 'bg-primary',
  success: 'bg-success',
  danger: 'bg-danger',
}

export function Progress({
  percent,
  showInfo = true,
  status = 'default',
  className,
}: ProgressProps) {
  const safe = Math.min(100, Math.max(0, percent))

  return (
    <div className={cn('flex items-center gap-3', className)}>
      <div className="h-1.5 min-w-0 flex-1 overflow-hidden rounded-full bg-border">
        <div
          className={cn(
            'h-full rounded-full transition-[width] duration-300',
            barClass[status],
          )}
          style={{ width: `${safe}%` }}
        />
      </div>
      {showInfo ? (
        <span className="w-10 shrink-0 text-right text-xs tabular-nums text-muted">
          {Math.round(safe)}%
        </span>
      ) : null}
    </div>
  )
}
